import './plugins/sentry'

import 'intersection-observer'
import Vue from 'vue'
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css' // only if your build system can import css, otherwise import it wherever you would import your css.

import App from './App.vue'
import router from './router'
import store from './store/index'
import i18n from './i18n'
import './validation'
import './registerServiceWorker'
// sempre dopo Vue
import './plugins/contentfulClient'

import VueWaypoint from 'vue-waypoint'
import VueLazyload from 'vue-lazyload'

Vue.use(VuePlyr)
Vue.use(VueWaypoint)

// or with options
Vue.use(VueLazyload)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  i18n.locale = store.getters.lang
  // netlify-pretty-urls
  if (to.path[to.path.length - 1] !== '/') return router.replace(`${to.path}/`)
  // lang html attribute
  const html = document.documentElement
  html.setAttribute('lang', store.getters.lang)
  next()
})

new Vue({
  created() {
    const html = document.documentElement // returns the html tag
    html.setAttribute('dir', 'ltr')
  },
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
